import React from "react";
import { observer } from "mobx-react";
import { RoleCreateStore } from "../../store";
import { RoleCreateForm } from "./RoleCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type RoleCreateProps = {
  roleCreateStore: RoleCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const RoleCreate: React.FC<RoleCreateProps> = observer(
  ({ roleCreateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={roleCreateStore.isSaving} />
        <RoleCreateForm
          roleCreateStore={roleCreateStore}
          name_esError={roleCreateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            roleCreateStore.setName_esValue(value);
          }}
          name_es={roleCreateStore.entityValues.name_es}
          name_enError={roleCreateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            roleCreateStore.setName_enValue(value);
          }}
          name_en={roleCreateStore.entityValues.name_en}
          name_ptError={roleCreateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            roleCreateStore.setName_ptValue(value);
          }}
          name_pt={roleCreateStore.entityValues.name_pt}
          permissionsError={roleCreateStore.errors.permissions?.message}
          onPermissionsChange={(value) => {
            roleCreateStore.setPermissionsValue(value);
          }}
          permissionsSelectedValues={
            roleCreateStore.entityValues.showPermissions
          }
          onPermissionsSelected={(value) => {
            roleCreateStore.setSelectedPermissions(value);
          }}
          permissionsOptions={roleCreateStore.getPermissionsOptions()}
          audienceError={roleCreateStore.errors.audience?.message}
          onAudienceChange={(value: string) => {
            roleCreateStore.setAudienceValue(value);
          }}
          audience={roleCreateStore.entityValues.audience}
          isForAllTenantsError={roleCreateStore.errors.isForAllTenants?.message}
          onIsForAllTenantsChange={(value: boolean) => {
            roleCreateStore.setIsForAllTenantsValue(value);
          }}
          isForAllTenants={roleCreateStore.entityValues.isForAllTenants}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={roleCreateStore.isProcessing}
          onSave={() => roleCreateStore.saveNewRole()}
          onCancel={() => roleCreateStore.cancelNewRole()}
        />
        <ErrorDialog
          open={roleCreateStore.errorDialogOpened}
          title={roleCreateStore.errorTitle}
          description={roleCreateStore.errorDescription}
          onClose={() => roleCreateStore.closeErrorDialog()}
        />
      </>
    );
  }
);
